














































































import { Component, Vue } from 'vue-property-decorator';
import { APP_CONFIG } from '@/config/app-config';

@Component
export default class WalletInfo extends Vue {
    get userInfo() {
        return this.$store.state[APP_CONFIG.stateKey.authStore].userInfo || {};
    }

    get customerInfo() {
        return this.$store.state[APP_CONFIG.stateKey.authStore].customerInfo || {};
    }

    get customerLevels() {
        return this.$store.state[APP_CONFIG.stateKey.commonStore].customerLevels;
    }

    get customerLevelsDetail() {
        return (this.customerLevels || []).find((cl: any) => cl.ID === (this.customerInfo.LevelID || 1));
    }
}
